import uniqBy from 'lodash/uniqBy';
import { Page } from '../../../Online/OnlineApplicationForm/useApplicationFormFlow';

export enum OnlineStep {
    OrderDetails = 'formProgressBar_OrderDetails',
    UserDetails = 'formPageRegistration_YourDetails',
    Payment = 'formProgressBar_Payment',
    StartDate = 'formProgressBar_StartDate',
    Confirmation = 'formProgressBar_Confirmation',
}

export class OnlineProgress {
    private static readonly ProgressBarDictionary: Record<Page, OnlineStep> = {
        [Page.OrderDetails]: OnlineStep.OrderDetails,
        [Page.Login]: OnlineStep.UserDetails,
        [Page.Registration]: OnlineStep.UserDetails,
        [Page.StartDate]: OnlineStep.StartDate,
        [Page.PaymentOptions]: OnlineStep.Payment,
        [Page.Payment]: OnlineStep.Payment,
        [Page.Confirmation]: OnlineStep.Confirmation,
    };

    public static readonly ProgressDictionaryKeys = Object.keys(OnlineProgress.ProgressBarDictionary) as Page[];

    private static readonly Steps = OnlineProgress.ProgressDictionaryKeys.map(
        key => OnlineProgress.ProgressBarDictionary[key]
    );

    public static readonly UniqueSteps = uniqBy(OnlineProgress.Steps, e => e);

    public static getActiveStep = (activePage: Page) => OnlineProgress.ProgressBarDictionary[activePage];

    public static getActiveStepIndex = (activePage: Page) =>
        OnlineProgress.UniqueSteps.indexOf(OnlineProgress.getActiveStep(activePage));
}
